require('dotenv').config()

// GC STORAGE

export const profilePictureBucket = process.env.GCPROFILEBUCKET
export const keyFilename = process.env.GCKEYFILENAME
export const projectId = process.env.GCPROJECTID

// ----- CREDENTIALS FROM ENV WILL BE DEPRECATED 12/13/2024 ----- //
// export const credentials = {
//     client_email: process.env.GCEMAIL,
//     private_key: process.env.GCPRIVATEKEY
// }

export const publicBucketName = "elysium-emr-main"
export const GCpublicUrl = "https://storage.googleapis.com"

//WEBSITE MAIN OF GOOGLE CLOUD RUN
export const CloudRunWebsite = "http://emr.elysiummedicalph.com"